import { render, staticRenderFns } from "./PurchasingPaymentGroup.vue?vue&type=template&id=1d8e14d8&"
import script from "./PurchasingPaymentGroup.vue?vue&type=script&lang=js&"
export * from "./PurchasingPaymentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports